<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  
  <!-- No Submission ID Message -->
  @if (noSubmissionId) {
<div>
    <div class="col-md-12">
      <span class="noRecords">Submission details not found for the group {{rowData.GROUP_NAME}} so can't display the duplicate data.</span>
    </div>
  </div>
}

  <!-- Loading Indicator -->
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  <!-- No Records Found Message -->
  @if (!loading && noRecords) {
<div>
    <div class="col-md-12">
      <span class="noRecords">No Records Found.</span>
    </div>
  </div>
}

  <!-- Tables Display -->
  @if (!loading && showTables) {
<div>
    
    <!-- S3 Table -->
    <div style="margin-top:15px">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-hover table-bordered table-striped table-condensed custom-table">
            <thead>
              <tr>
                <th colspan="6" style="text-align: center;">S3</th>
              </tr>
              <tr>
                <th>TAX YEAR</th>
                <th>SUBMISSION ID</th>
                <th>KEY ID</th>
                <th>LE TYPE</th>
                <th>IRS FORM NO</th>
                <th>COUNT</th>
              </tr>
            </thead>
            <tbody>
              @for (obj of sltIsDuplicateData.P_S3_URL_DUP_DATA; track $index) {
<tr>
                <td>{{obj.tax_year}}</td>
                <td>{{obj.submission_id}}</td>
                <td>{{obj.key_id}}</td>
                <td>{{obj.let_type}}</td>
                <td>{{obj.irs_form_no}}</td>
                <td>{{obj.count}}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
      @if (sltIsDuplicateData.P_S3_URL_DUP_DATA && sltIsDuplicateData.P_S3_URL_DUP_DATA.length === 0) {
<div class="col-md-12">
        <span class="noRecords">No Records Found.</span>
      </div>
}
    </div>

    <!-- CORP Table -->
    <div style="margin-top:15px">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-hover table-bordered table-striped table-condensed custom-table">
            <thead>
              <tr>
                <th colspan="10" style="text-align: center;">CORP</th>
              </tr>
              <tr>
                <th>LEID</th>
                <th>JOB ID</th>
                <th>OBJECT KEY</th>
                <th>ELEMENT NAME</th>
                <th>PARENT ELEMENT NAME</th>
                <th>SNO</th>
                <th>PARENT SNO</th>
                <th>SUBFORM</th>
                <th>BLOCK TYPE</th>
                <th>COUNT</th>
              </tr>
            </thead>
            <tbody>
              @for (obj of sltIsDuplicateData.P_CORP_DUP_DATA; track $index) {
<tr>
                <td>{{obj.leid}}</td>
                <td>{{obj.job_id}}</td>
                <td>{{obj.object_key}}</td>
                <td>{{obj.element_name}}</td>
                <td>{{obj.parent_element_name}}</td>
                <td>{{obj.sno}}</td>
                <td>{{obj.parent_sno}}</td>
                <td>{{obj.subform}}</td>
                <td>{{obj.block_type}}</td>
                <td>{{obj.count}}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
      @if (sltIsDuplicateData.P_CORP_DUP_DATA && sltIsDuplicateData.P_CORP_DUP_DATA.length === 0) {
<div class="col-md-12">
        <span class="noRecords">No Records Found.</span>
      </div>
}
    </div>

    <!-- PARTNERSHIP Table -->
    <div style="margin-top:15px">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-hover table-bordered table-striped table-condensed custom-table">
            <thead>
              <tr>
                <th colspan="10" style="text-align: center;">PARTNERSHIP</th>
              </tr>
              <tr>
                <th>LEID</th>
                <th>JOB ID</th>
                <th>OBJECT KEY</th>
                <th>ELEMENT NAME</th>
                <th>PARENT ELEMENT NAME</th>
                <th>SNO</th>
                <th>PARENT SNO</th>
                <th>SUBFORM</th>
                <th>BLOCK TYPE</th>
                <th>COUNT</th>
              </tr>
            </thead>
            <tbody>
              @for (obj of sltIsDuplicateData.P_PSHIP_DUP_DATA; track $index) {
<tr>
                <td>{{obj.leid}}</td>
                <td>{{obj.job_id}}</td>
                <td>{{obj.object_key}}</td>
                <td>{{obj.element_name}}</td>
                <td>{{obj.parent_element_name}}</td>
                <td>{{obj.sno}}</td>
                <td>{{obj.parent_sno}}</td>
                <td>{{obj.subform}}</td>
                <td>{{obj.block_type}}</td>
                <td>{{obj.count}}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
      @if (sltIsDuplicateData.P_PSHIP_DUP_DATA && sltIsDuplicateData.P_PSHIP_DUP_DATA.length === 0) {
<div class="col-md-12">
        <span class="noRecords">No Records Found.</span>
      </div>
}
    </div>

    <!-- CONSOL Table -->
    <div style="margin-top:15px">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-hover table-bordered table-striped table-condensed custom-table">
            <thead>
              <tr>
                <th colspan="3" style="text-align: center;">CONSOL</th>
              </tr>
              <tr>
                <th>SUBMISSION ID</th>
                <th>TAX PAYER NAME</th>
                <th>COUNT</th>
              </tr>
            </thead>
            <tbody>
              @for (obj of sltIsDuplicateData.P_CONSOL_DUP_DATA; track $index) {
<tr>
                <td>{{obj.submission_id}}</td>
                <td>{{obj.tax_payer_name}}</td>
                <td>{{obj.count}}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
      @if (sltIsDuplicateData.P_CONSOL_DUP_DATA && sltIsDuplicateData.P_CONSOL_DUP_DATA.length === 0) {
<div class="col-md-12">
        <span class="noRecords">No Records Found.</span>
      </div>
}
    </div>

    <!-- MISSING XML Table -->
    <div style="margin-top:15px">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-hover table-bordered table-striped table-condensed custom-table">
            <thead>
              <tr>
                <th colspan="5" style="text-align: center;">MISSING XML</th>
              </tr>
              <tr>
                <th>GROUP NAME</th>
                <th>SUBMISSION ID</th>
                <th>LE KEY</th>
                <th>LEID</th>
                <th>COUNT</th>
              </tr>
            </thead>
            <tbody>
              @for (obj of sltIsDuplicateData.P_MISSING_XML_DATA; track $index) {
<tr>
                <td>{{obj.group_NAME}}</td>
                <td>{{obj.submission_ID}}</td>
                <td>{{obj.le_KEY}}</td>
                <td>{{obj.leid}}</td>
                <td>{{obj.cnt}}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
      @if (sltIsDuplicateData.P_MISSING_XML_DATA && sltIsDuplicateData.P_MISSING_XML_DATA.length === 0) {
<div class="col-md-12">
        <span class="noRecords">No Records Found.</span>
      </div>
}
    </div>

  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
